import { computed, ref } from 'vue'

import axios from 'axios'

const noncompliance_model_degrees_of_risk = ref([])
const noncompliance_model_degree_of_risk_filters = ref({})
const filtered_noncompliance_model_degrees_of_risk = ref([])

export default function useNoncomplianceModelDegreeOfRisk() {
  const listNoncomplianceModelDegreesOfRisk = async () => {
    axios
      .get('/api/noncompliance_model_degrees_of_risk/all')
      .then(function (response) {
        noncompliance_model_degrees_of_risk.value =
          filtered_noncompliance_model_degrees_of_risk.value = response.data.data
      })
      .catch(function () {})
  }

  return {
    noncompliance_model_degrees_of_risk: computed(
      () => noncompliance_model_degrees_of_risk.value,
    ),
    noncompliance_model_degree_of_risk_filters: noncompliance_model_degree_of_risk_filters,
    filtered_noncompliance_model_degrees_of_risk: computed(
      () => filtered_noncompliance_model_degrees_of_risk.value,
    ),
    listNoncomplianceModelDegreesOfRisk,
  }
}
